module.exports = __webpack_public_path__ + "static/media/ship.f591ee15.svg";